const TipoLimiarColors = function (paleta) {

	function get(idTipoLimiar, superior = true) {
		return paleta[idTipoLimiar + '_' + superior];
	}

	this.get = get;
};

const SerieAmostraColors = function (paleta) {

	function get(idSerie) {
		return paleta[idSerie];
	}

	this.get = get;
}; 

const tipoLimiarColorsForMap = new TipoLimiarColors({
	'20_true': '#08519c', //mMAD, azul
	'21_true': '#006d2c', //TIF, verde
	'22_true': '#6a51a3', //p98, tons de roxo
	'23_true': '#9e9ac8', //p95, tons de roxo
	'24_true': '#cbc9e2', //p90, tons de roxo
	'25_true': '#f2f0f7', //p75, tons de roxo

	'30_true': '#fee0d2', //Conama - Nível 1, sedimento, tons de vermelho
	'31_true': '#de2d26', //Conama - Nível 2, sedimento, tons de vermelho

	'32_true': '#fee5d9', //Conama - Prevenção, solo, tons de vermelho
	'33_true': '#fcae91', //Conama - Investigação agrícola, solo, tons de vermelho
	'34_true': '#fb6a4a', //Conama - Investigação residencial, solo, tons de vermelho
	'35_true': '#cb181d', //Conama - Investigação industrial, solo, tons de vermelho

	'36_true': '#A50F15', //Conama - Classe 2, água, vermelho
	'36_false': '#f768a1', //Conama - Classe 2, água, rosa

	'40_true': '#525252' //limite de quantificação, cinza
});

const tipoLimiarColorsForPlot = new TipoLimiarColors({
	'20_true': '#08519c', //mMAD, azul
	'21_true': '#006d2c', //TIF, verde
	'22_true': '#3f007d', //p98, tons de roxo
	'23_true': '#6a51a3', //p95, tons de roxo
	'24_true': '#9e9ac8', //p90, tons de roxo
	'25_true': '#dadaeb', //p75, tons de roxo

	'30_true': '#cb181d', //Conama - Nível 1, sedimento, tons de vermelho
	'31_true': '#67000d', //Conama - Nível 2, sedimento, tons de vermelho

	'32_true': '#fcbba1', //Conama - Prevenção, solo, tons de vermelho
	'33_true': '#fb6a4a', //Conama - Investigação agrícola, solo, tons de vermelho
	'34_true': '#cb181d', //Conama - Investigação residencial, solo, tons de vermelho
	'35_true': '#67000d', //Conama - Investigação industrial, solo, tons de vermelho

	'36_true': '#A50F15', //Conama - Classe 2, água, vermelho (limiar inferior não é usado nos plots, logo só há uma cor para esse tipo de limiar)

	'40_true': '#525252' //limite de quantificação, cinza
});

const serieAmostraColorsForMap = new SerieAmostraColors({
	'100': '#4292c6',
	'110': '#fff7bc',
	'ts': '#bdbdbd'
})

export { tipoLimiarColorsForMap, tipoLimiarColorsForPlot, serieAmostraColorsForMap }